// @flow

import {
  GET_USER_FAILURE,
  GET_USER_REQUEST,
  GET_USER_SUCCESS
  //GET_USER_COMPILED_QUESTS_FAILURE,
  //GET_USER_COMPILED_QUESTS_REQUEST,
  //GET_USER_COMPILED_QUESTS_SUCCESS
} from '../actions/profile'

import { UPDATE_ACCOUNT_SUCCESS } from '../actions/account'

const initialState: {
  isFetchingUser: boolean,
  //isFetchingQuests: boolean,
  user: null
  //quests: Array<Object>
} = {
  isFetchingUser: false,
  //isFetchingQuests: false,
  user: null
  //quests: []
}

export function profile(state: Object = initialState, action: Object): Object {
  switch (action.type) {
    case GET_USER_REQUEST:
      return Object.assign({}, state, {
        isFetchingUser: true,
        user: null
      })

    case GET_USER_SUCCESS:
      return Object.assign({}, state, {
        isFetchingUser: false,
        user: action.user
      })

    case GET_USER_FAILURE:
      return Object.assign({}, state, {
        isFetchingUser: false,
        user: null
      })

    /*
    case GET_USER_COMPILED_QUESTS_REQUEST:
      return Object.assign({}, state, {
        isFetchingQuests: true,
        quests: []
      })

    case GET_USER_COMPILED_QUESTS_SUCCESS:
      return Object.assign({}, state, {
        isFetchingQuests: false,
        quests: action.quests
      })

    case GET_USER_COMPILED_QUESTS_FAILURE:
      return Object.assign({}, state, {
        isFetchingQuests: false,
        quests: []
      })
    */

    case UPDATE_ACCOUNT_SUCCESS:
      const userUpdated = Object.assign({}, state.user)
      userUpdated.photo_url = action.file
      userUpdated.about = action.about
      return Object.assign({}, state, {
        user: userUpdated
      })

    default:
      return state
  }
}
